import React from "react";
import { ArrowDown, Star } from "lucide-react";
import { Button } from "./ui/button";

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-36">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/0g4e564k_slider-7-YlevMVVoPLiq1wn7.png"
          alt="Star Italia Interior Design"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 lg:px-6 max-w-4xl">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
          <span className="block">Il successo si costruisce</span>
          <span className="block text-blue-400">ogni giorno</span>
        </h1>

        <div className="text-xl md:text-2xl text-gray-200 mb-8 max-w-2xl mx-auto leading-relaxed text-center" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
          <p className="mb-4">
            Da oltre 3 generazioni ristrutturiamo case con passione, professionalità e competenza.
          </p>
          <p>
            Star Italia, Il meglio per la tua casa.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <Button
            size="lg"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            onClick={() => scrollToSection('services')}
          >
            I nostri servizi
          </Button>
          
          <Button
            variant="outline"
            size="lg"
            className="border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg transition-all duration-300 transform hover:scale-105"
            onClick={() => scrollToSection('contact')}
          >
            Contattaci
          </Button>
        </div>

        {/* Quote originale */}
        <div className="mt-16 max-w-2xl mx-auto">
          <blockquote className="text-lg md:text-xl text-gray-300 italic border-l-4 border-blue-400 pl-6">
            "Da oltre 3 generazioni ristrutturiamo case con passione"
          </blockquote>
        </div>

        {/* Marquee "Parlano di noi" - RIMPICCIOLITO */}
        <div className="mt-8 w-full max-w-4xl mx-auto px-4">
          <div className="bg-transparent rounded-xl p-3">
            <div className="text-center mb-3">
              <h3 className="text-sm font-bold text-white uppercase tracking-wider" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.9)' }}>PARLANO DI NOI</h3>
              <div className="w-16 h-0.5 bg-blue-400 mx-auto mt-2 shadow-lg"></div>
            </div>
            <div className="overflow-hidden w-full">
              <div className="flex animate-marquee-fast w-full">
                {/* Loghi con La Repubblica aggiunto */}
                <div className="flex items-center space-x-16 animate-scroll-fast min-w-full">
                  <img
                    src="/images/v78lny0q_LOGO_PAMBIANCONEWS_SOTTILE_02.png"
                    alt="Pambianconews"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 filter brightness-0 invert flex-shrink-0"
                  />
                  <img
                    src="/images/7d8t10is_ilsole24ore-o-2021.svg"
                    alt="Il Sole 24 Ore"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 filter brightness-0 invert flex-shrink-0"
                  />
                  <img
                    src="/images/0j3fwenr_MF_logo.png"
                    alt="Milano Finanza"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 filter brightness-0 invert flex-shrink-0"
                  />
                  <img
                    src="/images/dytd2lm5_la-repubblica-1024x537-1.png"
                    alt="La Repubblica"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 flex-shrink-0"
                    style={{ filter: 'none' }}
                  />
                  {/* Duplicazione con La Repubblica */}
                  <img
                    src="/images/v78lny0q_LOGO_PAMBIANCONEWS_SOTTILE_02.png"
                    alt="Pambianconews"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 filter brightness-0 invert flex-shrink-0"
                  />
                  <img
                    src="/images/7d8t10is_ilsole24ore-o-2021.svg"
                    alt="Il Sole 24 Ore"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 filter brightness-0 invert flex-shrink-0"
                  />
                  <img
                    src="/images/0j3fwenr_MF_logo.png"
                    alt="Milano Finanza"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 filter brightness-0 invert flex-shrink-0"
                  />
                  <img
                    src="/images/dytd2lm5_la-repubblica-1024x537-1.png"
                    alt="La Repubblica"
                    className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-all duration-200 hover:scale-110 flex-shrink-0"
                    style={{ filter: 'none' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <button
          onClick={() => scrollToSection('about')}
          className="text-white hover:text-blue-400 transition-colors duration-300 animate-bounce"
        >
          <ArrowDown className="h-8 w-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;